import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function CandidateRecordBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Candidate Record Batch" />;
}
